/**
 * Given a slug in the format of '123-product-name', this function returns '123'
 * which is the id of the product.
 *
 * @param {string} slug Slug of the product
 * @returns {string | null} Product id or null if slug is empty
 */
export function useProductSlugDecode(slug: string): string | null {
  if (!slug) return null

  const parts = slug.split('-')
  if (parts.length > 0) {
    return parts[0]
  }

  return null
}
